"use client";

import type { HomepageSsrBootstrap } from "@/providers/HomepageSsrProvider";
import BeemoApp from "../../../src/BeemoApp";
import ContentLandingPage from "../../../src/pages/academy/Content/ContentLandingPage";

export function ContentLandingPageApp({
  bootstrap,
}: {
  bootstrap: HomepageSsrBootstrap;
}) {
  return (
    <BeemoApp
      bootstrap={bootstrap}
      ssrContentLandingPageElement={<ContentLandingPage />}
    />
  );
}
